<template>
  <div>
    <template v-if="visible">
      <b-card>
        <div class="card-header">
          <i class='fa fa-align-justify'></i> Historial de compra
          <div class="pull-right">
            <template v-if="status">
              <b-button variant="success" size="sm" @click="abrirAsignador"><i class="fa fa-plus"></i> Asignar</b-button>
            </template>
            <template v-if="status">
              <b-button @click="exportExcel()" variant="primary" size="sm">
                <template v-if="excelLoading == false"><i class="fa fa-download"></i> Exportar historial</template>
                <template v-else><loader :size="'small'" :color="'white'">Exportando</loader></template>
              </b-button>
            </template>
          </div>
        </div>
        <div class="card-block">
          <dx-data-grid
                  :dataSource="compras"
                  :columns="columns"
                  :paging="paging"
                  :columnHidingEnabled="true"
                  :columnResizingMode="'widget'"
                  :allowColumnReordering="true"
                  :filterRow="{ visible: true }"
                  :groupPanel="{ visible: true }"
                  :allowColumnResizing="true"
                  :headerFilter="{ visible: true }"
                  :pager="{
                      showPageSizeSelector: true,
                      allowedPageSizes: [5, 10, 20],
                      showInfo: true
                  }"
          >
            <div slot="test" slot-scope="data" >
              <div>
                <a href="#" v-b-tooltip.hover title="Editar compra" @click.prevent="editar(data)"><i class="fa fa-edit"></i></a>
              </div>
            </div>
            <div slot="Cantidad" slot-scope="data">
              {{data.data.timbres | quantity}}
            </div>
          </dx-data-grid>
        </div>
      </b-card>
    </template>
    <template v-else>
      <b-card>
        <div class="card-header">
          <i class='fa fa-align-justify'></i> Historial de compra
          <div class="pull-right">
            <b-button variant="success" size="sm" @click="abrirAsignador">
            <i class="icon-plus"></i> Asignar
            </b-button>
          </div>
        </div>
        <h2 class="text-center">Sin compras.</h2>
      </b-card>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import Pagination from '@/views/components/Pagination'
import EventBus from '@/event-bus.js'
import store from '@/store'
import Loader from '@/components/Loader'
import { DxDataGrid } from 'devextreme-vue'

export default {
  name: 'Compras',
  props: ['informacion', 'status', 'Nombre'],
  data: function () {
    return {
      paging: {
        pageSize: 20,
        pageIndex: 0
      },
      columns: [ {
        dataField: 'fecha',
        caption: 'Fecha',
        dataType: 'date',
        sortOrder: 'desc',
        alignment: 'right',
        cellTemplate: function (cell, info) {
          let date = moment(info.data.fecha).format('DD-MMM-YYYY')
          let res = date.split('-')
          res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
          cell.append(res.join('-'))
        },
        width: 150
      }, {
        dataField: 'timbres',
        dataType: 'number',
        format: '###,###,###',
        caption: 'Cantidad',
        cellTemplate: 'Cantidad'
      }, {
        dataField: 'factura',
        dataType: 'number',
        format: '###,###,###',
        caption: 'No. Factura',
        width: 130
      }, {
        dataField: 'Tools',
        caption: 'Tools',
        cellTemplate: 'test',
        width: 70,
        headerFilter: false
      }],
      excelLoading: false,
      current: 1,
      item: 0,
      draft: {
        Id: this.$route.params.id,
        Type: 'compras'
      }
    }
  },
  methods: {
    editar (data) {
      console.log(data.data)
      EventBus.$emit('OpenEditarCompra', data.data)
    },
    changePage (index) {
      this.current = index
    },
    abrirAsignador () {
      let distribuidor = {
        Id: this.$route.params.id,
        Nombre: this.Nombre
      }
      EventBus.$emit('abrirModalAsignar', distribuidor)
    },
    exportExcel () {
      this.excelLoading = true
      let response = store.dispatch('distribuidorExcel', this.draft)
      response.then(response => {
        this.excelLoading = false
        window.open(response.data.url)
      })
    }
  },
  filters: {
    fecha (date) {
      return moment(date).format('DD-MMM-YYYY hh:mm:ss a')
    },
    name: function (str) {
      return (typeof str === 'undefined') ? str : (str.length > 24) ? str.substring(0, 22) + '...' : str
    },
    quantity: function (quan) {
      return (typeof quan === 'undefined') ? quan : quan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  components: {Pagination, Loader, DxDataGrid},
  computed: {
    compras: function () {
      return this.informacion
    },
    visible: function () {
      return (typeof this.informacion === 'undefined') ? this.informacion : this.informacion.length
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Historial/Compras.vue